import { i18n } from "../../../i18n/i18n";

import React, { Component, Fragment } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { RootState } from '../../../store'
import {
  replaceArrowElementStroke,
  replaceArrowElementFill,
  replaceArrowOpacity,
  ArrowElement
} from '../../../views/LabelBuilder/LabelBuilder.slice'
import Heading from '../../Heading'
import InputColor from '../../InputColor'
import InputText from '../../InputText'
import PositionProperty from './PositionProperty'

interface Props {
  selectedElement: ArrowElement
}

type CombinedProps = Props & ConnectedProps<typeof connector>

class ArrowProperties extends Component<CombinedProps> {
  handleInputChange = (name: string, value: string) => {
    const { selectedElement } = this.props
    if (!selectedElement) return
    const { id } = selectedElement
    if (name === 'stroke') this.props.replaceArrowElementStroke(id, value)
    if (name === 'fill')   this.props.replaceArrowElementFill(id, value)
    if (name === 'opacity') this.props.replaceArrowOpacity(id, Number(value))
  }

  render () {
    const { selectedElement } = this.props
    if (!selectedElement || selectedElement.type !== 'arrow') return
    return (
        <Fragment>
          <Heading
              className="mb-1"
              text={i18n("Arrow")}
              size="small" />
          <PositionProperty
              elementId={selectedElement.id}
              x={selectedElement.x}
              y={selectedElement.y}
          />
          <InputText
              type="number"
              name="opacity"
              value={String(selectedElement.opacity)}
              label={i18n("Transparency")}
              onChange={this.handleInputChange}
              enforceLimits={true} />
          <InputColor
              name="stroke"
              value={selectedElement.stroke}
              label="Border"
              onChange={this.handleInputChange} />
          <InputColor
              name="fill"
              value={selectedElement.fill}
              label="Fill"
              onChange={this.handleInputChange} />
        </Fragment>
    )
  }
}

function mapStateToProps (state: RootState) {
  return {}
}

const mapDispatchToProps = {
  replaceArrowElementStroke,
  replaceArrowElementFill,
  replaceArrowOpacity
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(ArrowProperties)